/**
 * Main
 *
 * Copyright (c) 2020 Aperia Company
 * Released under the MIT license
 */
//  export js
"use strict";

window.app = app;
$(function () {
  new app.Core();
  new app.Sticky();
  new app.Menu();
  new app.Custom();

  new app.Slider({
    el: "#main-slider",
    options: {
      arrows: false,
      fade: true,
      autoplay: true,
      infinite: true,
      pauseOnHover: true
    }
  });
  new app.Slider({
    el: "#partner-slider",
    options: {
      slidesToShow: 6,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2000,
      infinite: true,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    }
  });
  new app.Slider({
    el: "#product-slider",
    options: {
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    }
  });
  new app.SliderThumbnail({
    elParent: "#history-single-slider",
    elChild: "#history-slider-thumb",
    optionParent: {
      arrows: false,
      infinite: true,
      autoplay: true
    },
    optionChild: {
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      centerMode: true,
      prevArrow:
        '<button type="button" class="slide-prev"><i class="bi-chevron-left"></i></button>',
      nextArrow:
        '<button type="button" class="slide-next"><i class="bi-chevron-right"></i></button>',
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    }
  });
  new app.Slider({
    el: "#customer-slider",
    options: {
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    }
  });
  new app.SliderThumbnail({
    elParent: ".product-single-slider",
    elChild: ".product-single-thumb",
    optionParent: {
      arrows: true
    },
    optionChild: {
      slidesToShow: 3,
      slidesToScroll: 1
    }
  });

  new app.Slider({
    el: "#project-slider",
    options: {
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      autoplay: true,
      autoplaySpeed: 2000,
      pauseOnHover: true,
      centerPadding: "10px",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    }
  });
});
